export default __webpack_public_path__ + "static/media/Princess@1x.de194684.png";